import { ErrorDisplay } from 'components/ErrorDisplay';
import { Text } from 'components/mvp-typography';
import { formatISO } from 'date-fns';
import { ErrorBoundary } from 'react-error-boundary';
import {
  InventoryTableDisplay
} from './inventory-table-display/inventory-table-display';
import { InventoryTableDisplayProps } from './inventory-table-display/types';

export function InventoryTab(props: InventoryTableDisplayProps) {
  return (
    <div>
      <ErrorBoundary
        fallbackRender={props => (
          <ErrorDisplay
            title={'Oops something failed'}
            description="Please report this error to the ConcussionRx team."
            error={props.error}
          />
        )}
      >
        <Text>
          {formatISO(props.inventory.date.toDate(), { representation: 'date' })}
        </Text>
        <InventoryTableDisplay
          inventory={props.inventory}
          config={props.config}
          inventoryFilterConfig={props.inventoryFilterConfig}
        />
      </ErrorBoundary>
    </div>
  );
}
